import { t } from "@/i18n-js/instance";
import { Typography } from "@circle-react-uikit/Typography";
import { useBillingContext } from "./BillingContext";

const localeRoot = "settings.billing.manage_billing.plan_details";

export const PlanHeader = () => {
  const { currentPlan } = useBillingContext();

  if (!currentPlan) return null;

  return (
    <div className="flex flex-col">
      <Typography.LabelXl weight="semibold">
        {t(`${localeRoot}.plan_name.${currentPlan.tier}`)}
      </Typography.LabelXl>
      <Typography.LabelLg weight="semibold">
        {currentPlan.base_amount_with_interval}
      </Typography.LabelLg>
    </div>
  );
};
